/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import withLayout from './withLayout';

const Terms = () => (
  <div className='grey-section-full'>
    <div className='wrapper small'>
      <div className='div-block'>
        <h1 className='_1st-header shrink'>Terms &amp; Conditions</h1>
        <div className='line' />
      </div>
      <p>
        Access to this site (the "Site"), is provided by Entoro Capital, LLC
        (the "Company"). For purposes of these Terms of Use, the Company shall
        mean and include Company's affiliates and Company and Company's
        affiliates' respective directors and employees.
      </p>
      <p>
        Each time you use or cause access to the Site, you agree to be bound by
        the following terms and conditions ("Terms of Use"). Please read these
        Terms of Use carefully before using the Site. Your access, link to or
        use of this Site will constitute your acceptance of the Terms of Use. If
        you do not agree to these Terms of Use, you should not use the Site. The
        Terms of Use may be amended from time to time with or without notice to
        you. Modifications shall become effective immediately upon being posted.
        Accordingly, please continue to review the Terms of Use whenever
        accessing, linking to, or using this site. Your access, link to, or use
        of the site, or any service on this site, after the posting of
        modifications to the Terms of Use will constitute your acceptance of the
        Terms of Use, as modified. If, at any time, you do not wish to accept
        the Terms of Use, you may not access, link to, or use the site.
      </p>
      <p>
        By agreeing to the Terms of Use, you agree to the terms of our Privacy
        Statement, which is expressly incorporated into these Terms of Use. All
        personal data provided to us as a result of your use of the Site will be
        handled in accordance with our Privacy Statement.
      </p>
      <p className='last-2'>
        <strong>
          If you do not agree to the terms and conditions of this Terms of Use,
          you should immediately cease all usage of this Site.
        </strong>
        &nbsp;This Site may not be accessed or used by anyone under the age of
        18.
      </p>
      <h2 className='_2nd-header'>
        License to Use; Prohibition on Diverting Service Data
      </h2>
      <p>
        We grant you a personal, limited, non-exclusive, revocable,
        non-transferable and non-sublicenseable&nbsp;license to use the Platform
        pursuant to these Terms and Conditions. &nbsp;We may provide certain
        portions of the Platform under license from third parties, and you will
        comply with any additional restrictions on your usage that we may
        communicate to you from time to time, or that are otherwise the subject
        of an agreement between you and such licensors.
      </p>
      <p>
        We are providing the Platform to you only for your internal use and only
        for the purposes related to certain services provided to you by
        OfferBoard. &nbsp;You may not sell, lease, or provide, directly or
        indirectly, the Platform or any portion of the Platform to any third
        party without our written permission. &nbsp;You acknowledge that all
        proprietary rights in the Platform are owned by us or by any
        applicable&nbsp;third party&nbsp;service providers selected by us
        providing us with all or part of the Platform, or providing you with
        access to the Platform, or their respective licensors, and are protected
        under copyright, trademark and other intellectual property laws and
        other applicable law. &nbsp;You receive no copyright, intellectual
        property rights or other rights in or to the Platform, except those
        specifically set forth in these Terms and Conditions. &nbsp;You will
        protect and not violate those proprietary rights in the Platform and
        honor and comply with our reasonable requests to protect our
        contractual, statutory and common law rights in the Platform. &nbsp;If
        you become aware of any violation of our proprietary rights in the
        Platform, you will notify us in writing.
      </p>
      <p>
        As between OfferBoard and you, OfferBoard retains all ownership and
        other rights associate with the Platform generated data (Data).
      </p>
      <p className='last-2'>
        You may not divert Data from the Platform, either internally or
        externally, except as specifically authorized by OfferBoard.
        &nbsp;OfferBoard is not liable to you for any diverted, repackaged or
        disseminated Data. &nbsp;OfferBoard reserves the right to audit your
        usage of data in adherence to the OfferBoard requirements and
        limitations specified within these Terms and Conditions on an annual
        basis for the purposes of establishing and verifying that you have not
        diverted, repackaged or disseminated Data.
      </p>
      <h2 className='_2nd-header'>Securities Products</h2>
      <p className='last-2'>
        None of the information contained in the Platform constitutes a
        recommendation by OfferBoard or its affiliates to buy or sell any
        securities, futures, options or other financial instruments or other
        assets or provide any investment advice or service. &nbsp;The
        information contained in the Platform has been prepared without
        reference to any particular user's investment requirements or financial
        situation. &nbsp;The information and services provided on the Platform
        are not&nbsp;provided to, and may not be used by, any person or entity
        in any jurisdiction where the provision or use thereof would be contrary
        to applicable laws, rules or regulations of any governmental authority
        or regulatory or self-regulatory organization or where OfferBoard is not
        authorized to provide such information or services. &nbsp;Some products
        and services described in the Platform may not be available in all
        jurisdictions or to all customers.
      </p>
      <h2 className='_2nd-header'>No Warranty</h2>
      <p>
        The fact that the Company has made the data and services provided on
        this site available to you constitutes neither a recommendation that you
        enter into a particular transaction with a third party nor a
        representation that any product, service or offering described on this
        site is suitable or appropriate for you. The Company is not a party to
        any transaction you may determine to enter into directly with a company,
        investor or other user of the Site. Any discussion of the risks
        contained herein with respect to any transaction you may enter into
        directly should not be considered to be a disclosure of all risks or
        complete discussion of the risks related to any such transaction. You
        should neither construe any of the material contained herein as
        business, financial, investment, hedging, trading, legal, regulatory,
        tax, or accounting advice nor make the information available through
        this service the primary basis for any investment decisions made by or
        on behalf of you, your accountants, or your managed or fiduciary
        accounts, and you may want to consult your business advisor, legal, tax
        and accounting advisors concerning any contemplated transactions.
      </p>
      <p className='last-2'>
        The Site is provided by the Company on an "as is" and on an "as
        available" basis. The Company disclaims all warranties, express, implied
        or statutory, including without limitation implied warranties of
        merchantability and fitness for a particular purpose or course of
        performance or dealing, and any warranties that materials on the site
        are non-infringing. The Company&nbsp;makesno&nbsp;representations or
        warranties of any kind, express or implied, regarding the use or the
        results of this Site in terms of its correctness, accuracy, reliability,
        or otherwise. The Company does not warrant that the system, services, or
        any component thereof, will meet the requirements of the user or that
        the operation of the system, service, or any component thereof, will be
        uninterrupted or error free. The Company does not warrant that the Site
        will be secure; that the Site or the server that makes the Site
        available will be virus-free; or that information on the Site will be
        complete, accurate or timely. If you download any materials from this
        Site, you do so at your own discretion and risk. The Company does not
        undertake any obligation to correct or update any information contained
        on this Site. The Company shall have no liability for any interruptions
        in the use of this Site. Some jurisdictions do not allow the exclusion
        of implied warranties; therefore, the above-referenced exclusion is
        inapplicable in any such jurisdiction. The Company does not own nor
        control the third-party website that linked you to the registration
        pages comprising the Site.
      </p>
      <h2 className='_2nd-header'>Limitation of Liability</h2>
      <p className='last-2'>
        You expressly understand and agree that, to the full extent permitted by
        applicable laws, in no event will Company be liable for damages, losses
        and expenses of whatever nature and however arising, including without
        limitation direct or indirect, special, incidental,
        consequential,&nbsp;exemplary or punitive damages, losses or expenses,
        including but not limited to, damages for loss of profits, goodwill,
        use, data or other intangible loss, arising in connection with this site
        or use thereof or inability to use by any party, or in connection with
        any failure or performance, error, omission, interruption, defect, delay
        in operation or transmission, computer virus or line or system failure,
        even if the Company or its representatives are advised of the
        possibility of such damages, losses or expenses. Hyperlinks to or from
        other internet resources are accessed at your own risk and it is your
        responsibility to take all protective measures to guard against viruses
        or other destructive elements; the content, accuracy, opinions expressed
        and other links provided by these resources are not endorsed by the
        Company. This limitation of liability applies whether the alleged
        liability is based on contract, negligence, tort, strict liability or
        any other basis. Your sole remedy for dissatisfaction with the site
        and/or information contained on the site is to stop using the site. In
        the event that the foregoing disclaimer of liability is held to be
        invalid or unenforceable, you agree that the maximum cumulative
        aggregate liability of the Company to you for all damages, losses, and
        causes of action (whether in contract, tort (including, without
        limitation, negligence and strict liability), or otherwise) at any time
        shall be the lesser of 100USD or the aggregate cumulative amount paid by
        you to the Company up to and including the time of the incurrence of
        such liability, if any, to access the Site. You agree that any cause of
        action arising out of or related to the Site must commence within one
        (1) year after the cause of action accrues or the cause of action is
        permanently barred.
      </p>
      <h2 className='_2nd-header'>Indemnification</h2>
      <p className='last-2'>
        You agree to indemnify, defend and hold harmless Company, its parents,
        subsidiaries, affiliates, officers and employees from any claim or
        demand, including reasonable attorneys' and experts' fees and costs,
        arising out of your use of this Site, including information made
        available to you through this Site or the violation of this Terms of
        Use, including any breach of your covenants or agreements hereunder. The
        Company reserves the right, at its own expense, to assume exclusive
        defense and control of any matter otherwise subject to indemnification
        by you based on a third-party claim and, in such case, you agree to
        cooperate with Company in the defense of such matter.
      </p>
      <h2 className='_2nd-header'>OfferBoard Reg. CF Disclosure </h2>
      <p className='last-2'>
        Any person promoting an issuer’s offering under Regulation CF for
        compensation, whether past or prospective, as well as any founder or
        employee of an issuer engaging in promotional activity on the issuer’s
        behalf on OfferBoard, must clearly disclose in all communications on
        OfferBoard the fact that they are engaging in promotional activity on
        behalf of an issuer, and the receipt of any compensation. OfferBoard,
        and its licensed broker-dealer and operator Entoro Securities, LLC, are
        and seek to be compensated in connection with offerings and sales of
        securities on OfferBoard.
      </p>
      <h2 className='_2nd-header'>Site Use</h2>
      <p>
        Unauthorized use of the Site and systems, including, but not limited to,
        unauthorized entry into the Company's systems or misuse of any
        information is strictly prohibited. You may not use this Site in any
        manner that could damage, disable, overburden or impair any of Company
        site or service or interfere with any other party's use and enjoyment of
        any Company site or service. You may not attempt to gain unauthorized
        access to any Company site or service, computer systems or networks
        connected to any Company site or service, through hacking, password
        mining or any other means. You agree that you will not engage in any
        activities related to this Site that are contrary to applicable laws or
        regulations.
      </p>
      <p className='last-2'>
        Your "Information" means any information and materials you provide to
        the Company or other users in connection with your registration for or
        use of the Site. You are solely responsible for Your Information, and
        the Company acts merely as a passive conduit for your online
        distribution and publication of your Information. You hereby represent
        and warrant to the Company that your use of this Site and your
        Information (a) will not be false, inaccurate, incomplete or misleading;
        (b) will not be fraudulent or involve the sale of counterfeit or stolen
        items; (c) will not infringe any third party's copyright, patent,
        trademark, trade secret or other proprietary right or rights of
        publicity or privacy; (d) will not violate any state, federal, or local
        law, statute, ordinance, or regulation (including without limitation
        those governing export control, consumer protection, unfair competition,
        anti-discrimination or false advertising); (e) will not be defamatory,
        libelous, unlawfully threatening, or unlawfully harassing; (f) will not
        be obscene or contain child pornography or be harmful to minors; (g)
        will not contain any viruses, Trojan Horses, worms, time
        bombs,&nbsp;cancelbots&nbsp;or other computer programming routines that
        are intended to damage, detrimentally interfere with, surreptitiously
        intercept or expropriate any system, data or personal information; and
        (h) will not create liability for the Company or cause the Company to
        lose (in whole or in part) the services of its ISPs or other partners or
        suppliers.
      </p>
      <h2 className='_2nd-header'>Governing Jurisdiction</h2>
      <p className='last-2'>
        This Terms of Use will be governed by and construed in accordance with
        the laws of the State of Texas, without reference to its choice of law
        principles. The venue for any dispute will be Houston, Texas. The
        parties each irrevocably waive their right to a trial by jury in any
        action arising from or relating to this Terms of Use.
      </p>
      <h2 className='_2nd-header'>Proprietary Rights</h2>
      <p>
        OfferBoard and other OfferBoard trademarks and service marks referenced
        herein are trademarks and service marks of OfferBoard, LLC. &nbsp;You
        are prohibited from using any marks for any purpose without the written
        permission of OfferBoard, LLC or Entoro Group. &nbsp;Pursuant to Section
        512(c)(2) of the Copyright Act, OfferBoard, LLC designates the following
        agent to receive notifications of claimed infringement:
      </p>
      <div>
        <div className='terms-contact'>
          General Counsel
          <br />
          Entoro Capital, LLC
          <br />
          333 West Loop North, Suite 333
          <br />
          Houston, TX 77024
        </div>
      </div>
    </div>
  </div>
);

export default withLayout(Terms);



// WEBPACK FOOTER //
// ./src/components/Terms.js